import TemplateFactory from './Factory'

exports.TemplateFactory = TemplateFactory
